import React, { useEffect, useRef, useState } from 'react'
import { useLoading } from '../../../context/LoadingContext';
import { useTranslation } from 'react-i18next';
import { CustomAdvancedMenuList, CustomDialog } from '../../../components/StyledComponents';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { ControlpanelErrorButton, ControlpanelPrimaryButton, ControlpanelSecondaryButton, ControlpanelSuccessButton, GrayIconButton } from '../../../components/StyledButton';
import CloseIcon from '@mui/icons-material/Close';
import CustomInput from '../../../components/CustomInput';
import { useConnectWS, useGetDeviceDetails, useReadCard } from '../../../hooks/useCheckid';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import CustomSelect from '../../../components/CustomSelect';
import { useGetGeneralPolicyCountry } from '../../../hooks/useGeneralService';
import { initialSelectedPhoneCountry } from '../../../assets/data/common';
import DoneIcon from "@mui/icons-material/Done";
import ErrorIcon from "@mui/icons-material/ErrorOutline";
import CustomDatePicker from '../../../components/CustomDatePicker';
import { useAuth } from '../../../context/AuthContext';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { format } from 'date-fns';
import AddIcon from '@mui/icons-material/Add';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import {
    ClickAwayListener,
    Grow,
    Link,
    MenuItem,
    Paper,
    Popper,
} from "@mui/material";
import ImportIcon20pxSvg from '../../../assets/images/icons/ImportIcon20pxSvg';
import Webcam from "react-webcam";
import { eventApproved, eventRejected, getEventsVisitorsById, getRegistrationsList } from '../../../axios/Visitor/VisitorApi';
import avatar_2 from "../../../assets/images/logo/avatar-default-logo.png";
import { useSearchParams } from 'react-router-dom';
const DetailRegistrationsDialog = ({ id, onClose, refreshData, onRefresh }) => {
    const [show, hide] = useLoading();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [readingCard, setReadingCard] = useState(false);
    const [isMissingSoftware, setIsMissingSoftware] = useState(false);
    const getDevice = useGetDeviceDetails();
    const connectWS = useConnectWS();
    const readCard = useReadCard();
    const language = useSelector((state) => state.languageR.language);
    const [isReadCard, setIsReadCard] = useState(false);
    const [dataReadcard, setDataReadcard] = useState(null);
    const skipBlurRef = useRef(false);
    const [onBlurEvent, setonBlurEvent] = useState(false);
    const { data: countries } = useGetGeneralPolicyCountry();
    const [selectedPhoneCountry, setSelectedPhoneCountry] = useState(
        initialSelectedPhoneCountry
    );
    const { genaralSettingDateFormat } = useAuth();
    const [openAdvanced, setOpenAdvanced] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const [openCamera, setOpenCamera] = useState(false);
    const webcamRef = useRef(null);

    const capture = () => {
        const imageSrc = webcamRef.current.getScreenshot();

        setFormData((prev) => ({
            ...prev,
            faceImage: imageSrc,
        }));

        setOpenCamera(false);
    };

    const anchorRefAdvanced = useRef(null);
    const handleQuickFilterChange = () => {
    };
    const handleToggleAdvanced = () => {
        setOpenAdvanced((prev) => !prev);
    };
    const handleCloseAdvanced = (event) => {
        if (
            anchorRefAdvanced.current &&
            anchorRefAdvanced.current.contains(event.target)
        ) {
            return; // click vào button thì không close
        }
        setOpenAdvanced(false);
    };

    const initialFormData = {
        fullName: '',
        personalID: '',
        email: '',
        phone: '',
        joinDate: '',
        faceImage: '',
        status: '',
        reason: '',
        langId: localStorage.getItem("i18nextLngId")
    };

    const [formData, setFormData] = useState(initialFormData);

    const [validationMessages, setValidationMessages] = useState({
        fullName: "",
        personalID: "",
        email: "",
        phone: "",
        joinDate: "",
        reason: "",
    });

    const handleDataChange = (name, newData) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: newData,
        }));
    };

    useEffect(() => {
        const fetchDetail = async () => {
            if (!id) return;

            try {
                show();
                setIsLoading(true);

                const payload = {
                    eventVisitorId: id,
                    langId: localStorage.getItem("i18nextLngId"),
                };

                const res = await getEventsVisitorsById(payload);

                if (res?.data?.responseCode === 0) {

                    const found = res?.data?.data?.[0];

                    setFormData({
                        fullName: found?.fullName || "",
                        personalID: found?.citizenNumber || "",
                        email: found?.email || "",
                        phone: found?.mobile || "",
                        joinDate: found?.joinDate
                            ? format(new Date(found.joinDate), genaralSettingDateFormat)
                            : "",
                        faceImage: found?.profileImageBase64 || "",
                        status: found?.status || "",
                        langId: localStorage.getItem("i18nextLngId"),
                    });

                } else {
                    toast.error(
                        res?.data?.message ||
                        t("common.something-went-wrong")
                    );
                }

            } catch (error) {

                console.error(error);

                toast.error(
                    error?.response?.data?.message ||
                    t("common.something-went-wrong")
                );

            } finally {
                hide();
                setIsLoading(false);
            }
        };

        fetchDetail();
    }, [id, show, hide]);

    const handleCloseDialog = () => {
        setFormData(initialFormData);
        const params = new URLSearchParams(searchParams);
        params.delete("eventId");
        params.delete("eventVisitorId");
        setSearchParams(params);
        onClose();
    };

    const updateFormDataAndValidate = (name, value) => {
        if (name === 'departmentPrefix') {
            // Giới hạn 2 ký tự + uppercase
            const trimmedValue = value.toUpperCase().slice(0, 2);

            setFormData((prevData) => ({
                ...prevData,
                [name]: trimmedValue,
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        updateFormDataAndValidate(name, value);

        if (name === "phone") {
            const phone = value.trim();

            if (!phone) {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "",
                }));
            } else if (!/^\d{9,13}$/.test(phone)) {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "common.content-024", // bạn tự define i18n
                }));
            } else {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "",
                }));
            }
        }

        if (name === "email") {
            const email = value.trim();

            if (!email) {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "",
                }));
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "validation.email-invalid-format", // key i18n
                }));
            } else {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "",
                }));
            }
        }

        if (name === "reason") {
            setValidationMessages((prev) => ({
                ...prev,
                reason: value.trim()
                    ? ""
                    : "common.reason-required",
            }));
        }
    };

    const fileInputRef = useRef(null);

    const formatBase64Image = (base64) => {
        if (!base64) return "";

        if (base64.startsWith("data:image")) return base64;

        // detect loại ảnh (optional nâng cao)
        const isPng = base64.startsWith("iVBOR"); // PNG signature
        const type = isPng ? "image/png" : "image/jpeg";

        return `data:${type};base64,${base64}`;
    };

    const handleReject = async () => {

        if (!formData.reason?.trim()) {
            setValidationMessages((prev) => ({
                ...prev,
                reason: "common.reason-required",
            }));

            toast.error(t("common.reason-required"));
            return;
        }

        const payload = {
            langId: localStorage.getItem("i18nextLngId"),
            eventVisitorId: id,
            reason: formData.reason,
        };

        try {
            show();
            setIsLoading(true);

            const response = await eventRejected(payload);

            if (response?.status === 200) {
                toast.success(t("common.reject-successfully"));
                onRefresh?.();
                onClose?.();
            } else {
                toast.error(response?.data?.message || t("common.error"));
            }

        } catch (err) {

            toast.error(
                err?.response?.data?.message ||
                t("common.network-or-server-error")
            );

            console.error("Delete visitor event error:", err);

        } finally {
            hide();
            setIsLoading(false);
        }
    };

    const handleApprove = async () => {
        const payload = {
            langId: localStorage.getItem("i18nextLngId"),
            eventVisitorId: id,
        };
        try {
            show();
            setIsLoading(true);
            const response = await eventApproved(payload);

            // ✅ Kiểm tra status 200 thay vì message
            if (response?.status === 200) {
                toast.success(t("common.approve-successfully"));
                onRefresh?.();
                onClose?.();
            } else {
                toast.error(response?.data?.message || t("common.error"));
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || t("common.network-or-server-error"));
            console.error("Delete visitor event error:", err);
        } finally {
            hide();
            setIsLoading(false);
        }
    }

    return (
        <>
            <CustomDialog maxWidth={'md'} open loading={isLoading} onClose={handleCloseDialog} keepMounted>
                <DialogTitle>
                    <div className='flex justify-between'>
                        <div className='flex items-center gap-4'>
                            <p className='text-xl font-semibold '>{t('common.detail-registration')}</p>
                        </div>
                        <GrayIconButton onClick={handleCloseDialog} disabled={isLoading}>
                            <CloseIcon />
                        </GrayIconButton>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <div className='space-y-4 mt-4'>
                        <div className="flex items-start justify-center gap-3">
                            <div className="flex items-center justify-center overflow-hidden border border-gray-200 p-[5px] rounded-[4px]">
                                {formData.faceImage ? (
                                    <img
                                        src={
                                            formData.faceImage
                                        }
                                        alt="preview"
                                        className="w-[168px] h-[170px] object-cover rounded-[4px]"
                                    />
                                ) : (
                                    <img
                                        src={avatar_2}
                                        alt="preview"
                                        className="w-[168px] h-[170px] object-cover rounded-[4px]"
                                    />
                                )}
                            </div>
                        </div>

                        <div>
                            <label>{t('common.name')} <span className="text-red-500">*</span></label>
                            <CustomInput name='fullName' value={formData.fullName} handleInputChange={handleInputChange} disabled readOnly={true} />
                        </div>

                        <div>
                            <label>{t('common.personal-id')}<span className="text-red-500">*</span></label>
                            <div className="mt-2 relative flex items-center">
                                <input
                                    type="number"
                                    name="personalID"
                                    className={`form-control h-[40px] no-spin-buttons relative z-40 pr-12 ${!!validationMessages.personalID ? "invalid" : ""
                                        }`}
                                    value={formData.personalID}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // ✅ Chỉ cho phép tối đa 12 chữ số
                                        if (value.length <= 12) {
                                            handleInputChange(e);
                                            setFormData((prev) => ({ ...prev, fullName: "" }));
                                        }
                                    }}
                                    disabled
                                />
                            </div>
                        </div>

                        <div>
                            <label>{t('common.email')} <span className="text-red-500">*</span></label>
                            <div className="mt-2 relative flex items-center h-10">
                                <input
                                    type="text"
                                    name="email"
                                    className="form-control h-10 pr-10"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    disabled
                                />
                            </div>

                            {/* MESSAGE */}
                            {validationMessages.email && (
                                <p className="mt-2 text-sm text-red-500">
                                    {t(validationMessages.email)}
                                </p>
                            )}
                        </div>

                        <div className="space-y-2 col-span-2">
                            <label className="block">{t("common.phone")} <span className="text-red-500">*</span></label>
                            <div className="relative flex items-center h-10">
                                {/* <div className="flex items-center jus gap-1 ps-3.5 relative z-10">
                                    <img
                                        src={selectedPhoneCountry.nationFlag}
                                        alt="flag-icon"
                                        className="w-6"
                                    />
                                    <span className="text-black">
                                        {selectedPhoneCountry.callingCode}
                                    </span>
                                </div> */}
                                <input
                                    className={`absolute inset-0 -top-[1px] form-control h-10 ${!!validationMessages.phone ? "invalid" : ""
                                        } ${formData.phone && !validationMessages.phone ? "success" : ""
                                        }`}
                                    value=""
                                    onChange={() => { }}
                                    disabled
                                />
                                <input
                                    type="number"
                                    // placeholder={selectedPhoneCountry.placeHolder}
                                    name="phone"
                                    className="no-spin-buttons relative z-10 ml-2 flex-1 h-10 outline-none px-2 border-none rounded-r-md item-center !text-[#1F2937]"
                                    onChange={handleInputChange}
                                    value={formData.phone}
                                    disabled
                                    readOnly={true}
                                />
                                {formData.phone && !validationMessages.phone && (
                                    <span className="absolute inset-y-[-3px] right-0 px-3 py-3">
                                        <DoneIcon fontSize="small" className="text-green-500" />
                                    </span>
                                )}
                                {!!validationMessages.phone && (
                                    <span className="absolute inset-y-[-3px] right-0 px-3 py-3">
                                        <ErrorIcon fontSize="small" className="text-red-500" />
                                    </span>
                                )}
                            </div>
                            {validationMessages.phone && (
                                <p className="text-sm text-red-500 mt-1">
                                    {t(validationMessages.phone)}
                                </p>
                            )}
                        </div>

                        <div>
                            <label>{t('common.select-date')}</label> <span className='text-[#EF4444] ml-1'>*</span>
                            <CustomInput
                                name="joinDate"
                                value={formData.joinDate}
                                className=""
                                dataType="joinDate"
                                disabled
                                readOnly={true}
                            />
                        </div>
                        {!["APPROVED", "REJECTED"].includes(formData.status) && (<div>
                            <label>
                                {t("common.reason")}
                                <span className="text-red-500">*</span>
                            </label>

                            <CustomInput
                                name="reason"
                                className={`form-control h-10 ${validationMessages.reason ? "invalid" : ""
                                    }`}
                                value={formData.reason}
                                handleInputChange={handleInputChange}
                                placeholder={t("common.reason")}
                            />

                            {validationMessages.reason && (
                                <p className="mt-2 text-sm text-red-500">
                                    {t(validationMessages.reason)}
                                </p>
                            )}
                        </div>)}

                    </div>
                </DialogContent>
                {!["APPROVED", "REJECTED"].includes(formData.status) && (
                    <DialogActions>
                        <div className='flex gap-2 px-4 py-4'>
                            <ControlpanelSecondaryButton onClick={handleCloseDialog} disabled={isLoading}>
                                <p>{t('button.cancel')}</p>
                            </ControlpanelSecondaryButton>

                            <ControlpanelErrorButton
                                style={{
                                    color: '#fff',
                                }}
                                onClick={handleReject}
                                disabled={isLoading}
                            >
                                <p>{t('button.reject')}</p>
                            </ControlpanelErrorButton>

                            <ControlpanelSuccessButton
                                style={{
                                    color: '#fff',
                                }}
                                onClick={handleApprove}
                                disabled={isLoading}
                            >
                                <p>{t('button.approve')}</p>
                            </ControlpanelSuccessButton>
                        </div>
                    </DialogActions>
                )}
            </CustomDialog>
        </>
    )
}

export default DetailRegistrationsDialog